import { PureConnect, React } from '../../react';
import { INote, IParticipant, IQuestionDB, IUsergroup, isQuestion } from '../../types';
import { categoriesResource } from '../categories/resource';
import { notesEditor } from '../notes/resource';
import { selectors } from '../../meta/selectors';
import cx from './style.less';
import { participantsResource } from '../../participant/resource';
import { usergroupResource } from '../../usergroup/resource';
import { questionsEditor, questionsResource } from '../question/resource';

const maxStatus =6;

function GetStatusString(status?: number) {
    const statusses = [
        { id: 1, name: 'Nieuw' },
        { id: 2, name: 'Behandelen' },
        { id: 3, name: 'In behandeling' },
        { id: 4, name: 'Klaar voor publiceren' },
        { id: 5, name: 'Gepubliceerd' },
        { id: 6, name: 'Gearchiveerd' },                        
    ];
    if (!status || !statusses || status===undefined || status<1 || status>maxStatus)
        return '';
    return statusses[status-1].name;
}

export default PureConnect<{ item: INote, participant: IParticipant, visible?: boolean }>('DataItemQuestion')(
    (state, props) => ({
        categories: categoriesResource.selectors.items(state),
        docId: selectors.docId(state),
        pageId: selectors.pageId(state),
        allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
        allparticipantsgroups: usergroupResource.selectors.items(state).qSelect((item) => item as IUsergroup), 
        allQuestions: questionsResource.selectors.items(state),
    }),
    (dispatch) => ({
        selectNote: (note: INote, allQuestions: IQuestionDB[]) => {
            dispatch(notesEditor.actions.READ({ item: note }));
            var readquestion = false;
            if (isQuestion(note)) {                            
                var current = allQuestions.qWhere((x) => x.noteId === note.id).qFirst();
                if (current) {      
                    dispatch(questionsEditor.actions.READ({ item: current }));
                    readquestion = true; 
                }
            }  
            if (isQuestion(note) && !readquestion) {
                dispatch(questionsEditor.actions.READ_CANCEL({}));
            }            
        },
    }),
    ({ item, participant, allQuestions, visible, selectNote }) => {
        const onClickItem = () => {
                selectNote(item, allQuestions);
        };
        
        const onKeyDownNotTab = (ev: React.KeyboardEvent<HTMLLIElement>) => {
            if (ev.key==='Enter') {
                onClickItem();
            }
        };

        const question = allQuestions.qWhere((x) => x.noteId === item.id).qFirst() as IQuestionDB;
        const status = question && question.status ? question.status: 1;

        return ( 
            <li className={cx('data-item')} tabIndex={visible? -1: 0} onKeyDown={(event) => onKeyDownNotTab(event)} onClick={onClickItem}>
                <div className={cx('vraagofnotitie')}> 
                    <div className={cx('text-container')}>
                        <div className={cx('text-container_main')}>{item.text}</div>
                        <div className={cx('text-container_status', 'type', 'status'+ status.toString())}>
                            <span id={`id-ref-` + status ? status.toString() : ''}>{GetStatusString(status)}</span>
                        </div>                        
                        <div className={cx('text-container_author')}>
                            <span className={cx('icon-container', 'pencil')}></span>
                            <span className={cx('autho-name')}>{participant?participant.name : ''}</span>
                        </div>
                    </div>
                </div>
            </li>
        );
    },
);



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/dataitemquestion/index.tsx